import { History, PencilLine, PlusCircle } from "lucide-react";
import { fmtDateTime } from "@/components/ticketMeta";
import { APPT_STATUSES, fmtDT } from "@/lib/cal";

const LABELS = {
  staff_name: "Coleg", service_name: "Serviciu", start: "Data și ora", duration: "Durată",
  client_name: "Client", client_phone: "Telefon", address: "Adresă", notes: "Note", status: "Status",
};

const fmtVal = (field, v) => {
  if (v === "" || v == null) return "—";
  if (field === "start") return fmtDT(v);
  if (field === "duration") return `${v} min`;
  if (field === "status") return APPT_STATUSES.find((s) => s.value === v)?.label || v;
  return String(v);
};

export const HistoryList = ({ history = [] }) => (
  <ol className="relative space-y-5 border-l pl-6" data-testid="appt-history-list">
    {[...history].reverse().map((h, i) => (
      <li key={i} className="relative" data-testid={`appt-history-${i}`}>
        <span className="absolute -left-[34px] grid h-6 w-6 place-items-center rounded-full border bg-card">
          {h.action === "creat" ? <PlusCircle className="h-3.5 w-3.5 text-emerald-500" /> : <PencilLine className="h-3.5 w-3.5 text-primary" />}
        </span>
        <div className="text-sm">
          <b>{h.by}</b> {h.action === "creat" ? "a creat programarea" : "a modificat programarea"}
        </div>
        <div className="text-xs text-muted-foreground">{fmtDateTime(h.at)}</div>
        {h.changes?.length > 0 && (
          <ul className="mt-2 space-y-1 rounded-lg border bg-background/50 p-2 text-xs">
            {h.changes.map((c, j) => (
              <li key={j}>
                <span className="text-muted-foreground">{LABELS[c.field] || c.field}:</span>{" "}
                <span className="line-through opacity-60">{fmtVal(c.field, c.old)}</span> → <b>{fmtVal(c.field, c.new)}</b>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
    {!history.length && <li className="flex items-center gap-2 text-sm text-muted-foreground"><History className="h-4 w-4" /> Fără istoric</li>}
  </ol>
);
